import type { ShellAppFiche } from '../types.js';

/**
 * LA MENTION D'UNE PORTE QUE LIA, LE MCP ET FLUX NE VOIENT PAS.
 *
 * Ils ne lisent et n'ecrivent que les familles d'une liste blanche : l'union des
 * `iaFamilies` des fiches `taki.app.json`, generee cote serveur dans
 * `functions/src/ia/families-des-apps.ts` (`docs/FUNCTIONS.md`, paragraphe
 * « Familles »). Une porte dont la famille n'y est pas est absente de leur
 * catalogue, et rien ne le disait dans le Studio.
 *
 * LA LISTE VIENT DU REGISTRE DE L'HOTE, pas d'un second fichier genere : le
 * shell garde deja la fiche de chaque app (`ShellAppFiche`), donc l'union se
 * recalcule ici, et le test `ouvertures-ia.test.mjs` la compare au fichier du
 * serveur pour qu'elle ne puisse pas mentir. Pure, donc testee hors de React.
 */

/** Le libelle de la mention, le meme partout ou une porte est nommee. */
export const LIBELLE_HORS_IA = 'Hors Lia et Flux';

/** Le nom d'une famille du SDK, tel que `fautesDesOuvertures` (`scripts/ouvertures-des-apps.mjs`) l'accepte. */
const FAMILLE_RE = /^[a-z][A-Za-z0-9]*$/;

/** L'union des `iaFamilies` des fiches : ce que le serveur ouvre a Lia, au MCP et a Flux. */
export function famillesOuvertesDesFiches(
  fiches: Iterable<Pick<ShellAppFiche, 'iaFamilies'> | undefined>,
): ReadonlySet<string> {
  const ouvertes = new Set<string>();
  for (const fiche of fiches) for (const famille of fiche?.iaFamilies ?? []) ouvertes.add(famille);
  return ouvertes;
}

export interface MentionHorsIa {
  libelle: string;
  /** La raison, pour l'infobulle. */
  raison: string;
}

/**
 * La mention de la porte qui montre `famille`, ou `null`. Rien non plus quand la
 * liste n'est pas connue (`ouvertes` nulle : aucun registre monte, un test) ou
 * quand la porte n'a pas de famille (canvas, outil, jeu encore « a decider ») :
 * on ne dit pas « hors » de ce qu'on ne sait pas.
 */
export function mentionHorsIa(
  famille: string | null | undefined,
  ouvertes: ReadonlySet<string> | null,
): MentionHorsIa | null {
  if (ouvertes === null || famille == null || !FAMILLE_RE.test(famille)) return null;
  if (ouvertes.has(famille)) return null;
  return {
    libelle: LIBELLE_HORS_IA,
    raison: `Famille ${famille} : aucune app ne l'ouvre à Lia, au MCP ni à Flux`,
  };
}
